
export default {
  props: {
    item: { type: Object, default: () => {} },
    display: { type: [Boolean, Array], default: () => [] },
    hoverable: { type: Boolean, default: true },
  },
}
